import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_bold};
  `}
`;

export const SubTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body18_bold};
  `}
`;

export const GenderButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 210px;
    padding: 4px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 23px;
    gap: 4px;
  `}
`;

export const GenderButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    flex: 1 0 0;
    align-items: center;
    align-self: stretch;
    justify-content: center;
    padding: 8px 0;
    border: 1px solid ${theme.backgroundColor.bg_light_5_alpha};
    border-radius: 19px;
    color: ${theme.content.content_light_3};

    ${theme.fontStyle.text.body16_bold};

    &.on {
      background: ${theme.backgroundColor.bg_light_1};
      color: ${theme.content.content_dark_1};
    }
  `}
`;

export const GuideContainer = styled(FlexStack)`
  padding: 8px 16px 16px 16px;
  border: 1px solid ${({ theme }) => theme.stroke.stroke_1};
  border-radius: 16px;
  gap: 16px;
`;

export const GuideDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_4};
    ${theme.fontStyle.text.body14_medium};
  `}
`;

export const GuideTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.themeColor.negative2};
    ${theme.fontStyle.text.body14_medium};

    &.b {
      color: ${theme.themeColor.main_1};
    }
  `}
`;

export const GuideWrapper = styled.p`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body14_medium};
  `}
`;
